import { render } from "./UiIcon.vue?vue&type=template&id=017c3b7b"
import script from "./UiIcon.vue?vue&type=script&lang=js"
export * from "./UiIcon.vue?vue&type=script&lang=js"

import exportComponent from "D:\\laragon\\www\\leader-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__